import Actions from "../../actions";
import * as requestFromServer from "./giftCardApis";



export const getGiftCardsAction = (dataToBeSent, setLoading) => async(dispatch) =>{
    setLoading(true)
    const response = await requestFromServer.getGiftCards(dataToBeSent);
    if(response){
        setLoading(false);
        dispatch(Actions.createAction(Actions.GET_GIFT_CARDS_LIST, {giftCards:response}))
        return response
    }
    else {
        setLoading(false)
        return null
    }
}

export const createGiftCardAction = (dataToBeSent, setLoading) => async(dispatch) =>{
    setLoading(true)
    const response = await requestFromServer.createGiftCard(dataToBeSent);
    if(response){
        setLoading(false);
        return response
    }
    else {
        setLoading(false)
        return null
    }
}

export const updateGiftCardAction = (dataToBeSent, setLoading) => async(dispatch) =>{
    setLoading(true)
    const response = await requestFromServer.updateGiftCard(dataToBeSent);
    if(response){
        setLoading(false);
        return response
    }
    else {
        setLoading(false)
        return null
    }
}

export const getGiftCardByIdAction = (dataToBeSent, setLoading) => async(dispatch) =>{
    setLoading(true)
    const response = await requestFromServer.getGiftCardById(dataToBeSent);
    if(response){
        setLoading(false);
        return response
    }
    else {
        setLoading(false)
        return null
    }
}

export const deleteGiftCardByIdAction = (dataToBeSent, setLoading) => async(dispatch) =>{
    setLoading(true)
    const response = await requestFromServer.deleteGiftCardById(dataToBeSent);
    if(response){
        setLoading(false);
        return response
    }
    else {
        setLoading(false)
        return null
    }
}